import { AttributeBinder, View } from '@ribajs/core'
import { TwAbstractBreakpointBinder } from '../types/tw-abstract-breakpoint.binder.js'

/**
 * Responsive attribute breakpoint binder
 * This binder is used to pass attributes to an element that should only be set at certain breakpoints (viewport widths).
 * @example
 * ```html
 *  <img
 *    rv-tw-attr-xxs-src="'https://picsum.photos/100'"
 *    rv-tw-attr-xs-src="'https://picsum.photos/200'"
 *    rv-tw-attr-sm-src="'https://picsum.photos/500/200'"
 *    rv-tw-attr-md-src="'https://picsum.photos/1000/500'"
 *
 *    rv-tw-attr-xxs-alt="'Image for very small displays'"
 *    rv-tw-attr-xs-src="'Image for small displays'"
 *    rv-tw-attr-sm-src="'Image for smartphones'"
 *    rv-tw-attr-md-src="'Image for tablets and small laptops'"
 *  />
 * ```
 */
export class TwAttributeBreakpointBinder extends TwAbstractBreakpointBinder<HTMLElement> {
  static key = 'tw-attr-*-*'

  defaultAttributeBinder: AttributeBinder

  constructor(
    view: View,
    el: HTMLElement,
    type: string | null,
    name: string,
    keypath: string | undefined,
    formatters: string[] | null,
    identifier: string | null,
  ) {
    super(view, el, type, name, keypath, formatters, identifier)
    this.defaultAttributeBinder = new AttributeBinder(
      view,
      el,
      this.attributeName,
      name,
      keypath,
      formatters,
      '*',
    )
  }
}
